import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import { getTaxList } from "@/api/tax/getTaxList";

export function TaxList() {
  const query = getTaxList.useQuery();

  if (query.isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (query.isError) {
    return (
      <Alert severity="error">
        Failed to load tax rules: {JSON.stringify(query.error)}
      </Alert>
    );
  }

  const taxes = query.data ?? [];

  return (
    <>
      <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: "calc(100vh - 160px)" }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Account</TableCell>
              <TableCell align="right">Percent</TableCell>
              <TableCell>Active</TableCell>
              <TableCell>Inclusive</TableCell>
              <TableCell>Sale</TableCell>
              <TableCell>Purchase</TableCell>
              <TableCell align="right">Components</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {taxes.map((tax) => (
              <TableRow key={tax.id} hover>
                <TableCell sx={{ fontFamily: "monospace" }}>{tax.id}</TableCell>
                <TableCell>{tax.name}</TableCell>
                <TableCell>{tax.account}</TableCell>
                <TableCell align="right">{tax.taxPercent}</TableCell>
                <TableCell>{tax.isActive ? "Yes" : "—"}</TableCell>
                <TableCell>{tax.isInclusive ? "Yes" : "—"}</TableCell>
                <TableCell>{tax.isForSale ? "Yes" : "—"}</TableCell>
                <TableCell>{tax.isForPurchase ? "Yes" : "—"}</TableCell>
                <TableCell align="right">{tax.components.length}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
